import i18n from "i18next";

export const parseApiErrorIntoMessage = (error, isActionBasedError) => {
  try {
    const hasKey = i18n.exists(error.message);
    const msg = hasKey ? i18n.t(error.message) : null;
    if (msg) return msg;
    return msg || error.message || isActionBasedError
      ? i18n.t("somethingWentWrongTryAgain")
      : i18n.t("somethingWentWrong");
  } catch {
    return i18n.t("somethingWentWrong");
  }
};
